import { render, staticRenderFns } from "./SampleCohortSelector.vue?vue&type=template&id=40a86a48"
import script from "./SampleCohortSelector.vue?vue&type=script&lang=js"
export * from "./SampleCohortSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports